import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../../core/services/core.title.service';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { BreadcrumbService } from '../../../widgets/breadcrumbs/breadcrumbs.service';
import { UserService } from '../../../core/services/core.user.service';
import { UiService } from '../../../core/services/core.ui.service';

import * as _ from 'lodash';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Component({
    selector: 'wiki-monitor',
    template: require('./wiki.monitor.component.html')
})
export class WikiMonitorComponent implements OnInit {

    @Input() project: any = null;
    @Input() wikiPage: any = null;
    @Input() wikiMonitors: any = null;
    @Input() pageMonitors: any = null;

    protected pageName: string = '';
    protected user: any = null;
    $state: StateService;

    constructor(
        private $window: Window,
        private wikiService: WikiService,
        private breadcrumbService: BreadcrumbService,
        private gfTranslateService: GfTranslateService,
        private stateService: StateService,
        private userService: UserService,
        private uiService: UiService,
        private titleService: GfTitleService,
    ) {
        this.$state = stateService;
    }
    
    ngOnInit() {
        this.pageName = _.get(this.wikiPage, 'pagename', 'FrontPage');
        this.titleService.setTitle(_.get(this.project, 'name', ''), 'Wiki', this.pageName + ' - Monitors');
        this.user = this.userService.session.getUser();

        this.breadcrumbService.setCrumbs([
            this.breadcrumbService.projectCrumb(this.project),
            this.breadcrumbService.translatedCrumb(marker('Wiki'), 'home.project.summary.wiki', { pagename: 'FrontPage' }),
            this.breadcrumbService.stateCrumb(this.pageName, 'home.project.summary.wiki.page', { pagename: this.pageName }),
            this.breadcrumbService.translatedCrumb(marker('Monitor'), '.', {})
        ]);
    };

    deleteMonitor = (item,section) => {
        var userId = item.user.id;
        var userName = item.user.unixName
        var refId = 0;

        if (section == 'wikipage') {
            refId = this.wikiPage.id;
        } else {
            refId = this.project.id;
        }
        this.wikiService.deleteMonitor(section, refId, userId)
        .then(() => {
            if (section == 'wikipage') {
                _.remove(this.pageMonitors.items, function(currentItem: any) { return userId == currentItem.user.id; })
            } else {
                _.remove(this.wikiMonitors.items, function(currentItem: any) { return userId == currentItem.user.id; })
            }
            this.uiService.message.showSuccess("User  " + userName + " removed from monitoring list");
        }, (response) => {
            this.uiService.message.showError("Unable to delete user from monitoring list");
            console.log(item, response);
        });
    };
}